import { useState } from 'react';
import { stepAnchor, type CalendarMode } from './calendar.logic';

/** What the period offers its consumers. */
export type ICalendarPeriod = ReturnType<typeof useCalendarPeriod>;

/**
 * What the calendar is looking at: the mode, the period on screen and the
 * picked day. Lives above the view, so closing the calendar (which unmounts the
 * view) keeps the viewer's place. A viewer still on today follows the site's
 * day when it turns; one who browsed elsewhere stays there.
 */
export function useCalendarPeriod(today: string) {
  const [mode, setMode] = useState<CalendarMode>('month');
  const [anchor, setAnchor] = useState(today);
  const [selected, setSelected] = useState(today);
  const [seenToday, setSeenToday] = useState(today);

  if (today !== seenToday) {
    setSeenToday(today);
    if (selected === seenToday) setSelected(today);
    if (anchor === seenToday) setAnchor(today);
  }

  return {
    mode,
    anchor,
    selected,
    select: setSelected,
    step: (by: number) => setAnchor(stepAnchor(mode, anchor, by)),
    goToToday: () => {
      setAnchor(today);
      setSelected(today);
    },
    /** Pages to `day` and picks it. */
    goTo: (day: string) => {
      setAnchor(day);
      setSelected(day);
    },
    changeMode: (next: CalendarMode) => {
      setMode(next);
      setAnchor(selected);
    },
  };
}
